const pageLoaders = {
  "/login": () => import("@/pages/LoginPage"),
  "/forgot-password": () => import("@/pages/ForgotPasswordPage"),
  "/reset-password": () => import("@/pages/ResetPasswordPage"),
  "/setup-account": () => import("@/pages/SetupAccountPage"),
  "/": () => import("@/pages/DashboardPage"),
  "/projects": () => import("@/pages/ProjectsPage"),
  "/projects/:id": () => import("@/pages/ProjectDetailPage"),
  "/reports": () => import("@/pages/ReportDashboardPage"),
  "/project-status-report": () => import("@/pages/ProjectStatusReportPage"),
  "/deadlines": () => import("@/pages/DeadlineDashboardPage"),
  "/sub-contractors": () => import("@/pages/SubContractorsPage"),
  "/tasks": () => import("@/pages/TasksPage"),
  "/tracker": () => import("@/pages/AssignmentTrackerPage"),
  "/calendar": () => import("@/pages/StaffCalendarPage"),
  "/accounting": () => import("@/pages/AccountingDashboardPage"),
  "/accounting-alerts": () => import("@/pages/AccountingAlertsPage"),
  "/clients": () => import("@/pages/ClientsPage"),
  "/users": () => import("@/pages/UsersPage"),
};

const preloaded = new Set();

export function loadPage(path) {
  const loader = pageLoaders[path];
  if (!loader) return Promise.resolve();
  return loader();
}

export function preloadRoute(path) {
  if (!pageLoaders[path] || preloaded.has(path)) return;
  preloaded.add(path);
  pageLoaders[path]().catch(() => {
    preloaded.delete(path);
  });
}
